import React, { FC } from 'react';
import { UsersListStyled } from './styles';
import { SubscribersTable } from './components';
import { useTranslation } from 'react-i18next';
import { useSubscription } from 'common/hooks/useSubscription';
import SubscriptionsBlocked from 'common/components/SubscriptionsBlocked';
import SubscriptionsExpiredSoon from 'common/components/SubscriptionsExpiredSoon';

const SubscribersList: FC = () => {
  const { t } = useTranslation();
  const { isExpiredSoon, isBlocked } = useSubscription();

  if (isBlocked) {
    return <SubscriptionsBlocked />;
  }

  return (
    <UsersListStyled>
      {isExpiredSoon && <SubscriptionsExpiredSoon />}
      <h1>{t('subscriptions.my_subscribers')}</h1>
      <SubscribersTable />
    </UsersListStyled>
  );
};

export default SubscribersList;
